export default __webpack_public_path__ + "static/media/udaf-logo.eded8452.svg";